'use strict';

import $ from 'jquery';
import DFClipboard from '@/js/modules/clipboard';
import { isValidImage } from '@/js/modules/file_validation';
import { prepareImagePreview, stripFileName } from '@/js/modules/uploads';
import '@/js/modules/jquery_modal_defaults';
import { onPageLoad } from '@/js/modules/page_load';

onPageLoad(() => {
  $(function () {
    if ($('body').is('#design-packages-form')) {
      $('.select-field--design-package-sales-tax')
        .find('option[value=select_a_sales_tax]')
        .text('No Tax');

      $(document).on('change', '#design-packages-page__show-phone', function () {
        $('#design_packages_page_show_phone').val($(this).is(':checked') ? 'true' : '');

        return false;
      });
      $(document).on('click', '.h-s-button--copy-design-package-link', (e) => {
        e.preventDefault();
        const textFieldSelector = $(e.target)
          .parents('.design-package-link__container')
          .find('.field--design-package-link')
          .attr('id');
        new DFClipboard(`#${textFieldSelector}`).copy();
        $(e.target)
          .closest('.design-package-link__copy-design-package-link')
          .find('.df-tooltip__text')
          .remove();
        $(e.target).before(
          `
            <span class="df-tooltip__text">Copied to Clipboard</span>
          `
        );
        $(e.target)
          .closest('.design-package-link__copy-design-package-link')
          .find('.df-tooltip__text')
          .show();

        setTimeout(() => {
          $(e.target)
            .closest('.design-package-link__copy-design-package-link')
            .find('.df-tooltip__text')
            .fadeOut();
        }, 1000);

        return false;
      });

      $(document).on('click', '.design-package__delete-package', function () {
        if ($('.design-package__packages .design-package__package').length < 2) {
          alert('At least one package has to be present');
          return false;
        }

        const packageId = $(this).closest('.design-package__package').index();
        $('#modal--delete-confirmation--package').data('package-id', packageId).modal();
        return false;
      });

      $(document).on('click', '.d-button--confirm-delete', function () {
        const packageId = $('#modal--delete-confirmation--package').data('package-id');
        $('.design-package__package')
          .eq(packageId)
          .fadeOut(300, function () {
            $(this).remove();
            $('#modal--delete-confirmation--package').attr('data-package-id', '');
          });
        $.modal.close();
        return false;
      });

      $('.design-package__packages').sortable({
        handle: '.drag-handle--design-package',
        cursor: 'move',
        tolerance: 'pointer',
        stop() {
          $('.design-package__sort-order').each((i, target) => $(target).val(i));
        },
      });

      $(document).on('keydown', function (e) {
        const $focusedListItem = $('.design-package__list-item:focus');
        const itemsCount = $focusedListItem
          .closest('.design-package__edit-list')
          .find('.design-package__list-item').length;

        if ($focusedListItem && e.which === 13 && $focusedListItem.val()) {
          const $newField = $(
            '.design-package__list-item-placeholder .design-package__list-item'
          ).clone();

          const index = $focusedListItem.closest('.design-package__package').data().index;

          // TODO: hook up
          $newField.attr('name', `packages[${index}][features][]`);

          $focusedListItem.after($newField);
          $newField.focus();
          return false;
        }
        if ($focusedListItem && e.which === 8 && $focusedListItem.val() === '') {
          if (itemsCount >= 2) {
            $focusedListItem.blur();
            return false;
          }
        }
      });

      $(document).on('blur', '.design-package__list-item', function () {
        const itemsCount = $(this)
          .closest('.design-package__edit-list')
          .find('.design-package__list-item').length;
        if (!$(this).val() && itemsCount >= 2) {
          const focusField = $(this).is(':first-child') ? $(this).next() : $(this).prev();
          const focusFieldVal = focusField.val();
          focusField.val('').focus().val(focusFieldVal);
          $(this).remove();
        }
      });

      $(document).on('click', '.design-package__add-package', () => {
        const index = $('.design-package__packages .design-package__package').length;
        $.get(`/design-packages/xhr_new/${index}`).then((data) => {
          const $packageBlock = $(data);

          $('.design-package__packages').append($packageBlock);
          updateRoomSelectorLabel($packageBlock);
        });

        return false;
      });
      $(document).on(
        'click',
        '.p-button--design-package, .h-s-button--submit-design-package-and-redirect',
        (e) => {
          const $button = $(e.target);
          const $form = $button.closest('form');
          if ($button.hasClass('h-s-button--submit-design-package-and-redirect')) {
            $('#redirect_to_preview').val('true');
          }
          $('#design_packages_page_sort_order').val(
            $('.design-package__package--free-consultation').index() - 1
          );

          // when saving packages - set roomNumber to 0 for all packages which are charged per room
          $form.find('.design-package__package').each((i, packageElement) => {
            const $package = $(packageElement);
            const chargePerRoom = $package.find('.green-checkbox--charge-per-room').is(':checked');
            const roomsNumberDropdown = $package.find('.select-field--rooms-number');
            const selectedRoomsText = roomsNumberDropdown.find('option:selected').text();
            if (chargePerRoom) {
              roomsNumberDropdown
                .prop('disabled', false)
                .append(`<option value="0" selected>${selectedRoomsText}</option>`)
                .css('opacity', 0.4);
            }
          });
          $form.submit();
          return false;
        }
      );

      $(document).on('change', '.green-checkbox--charge-per-room', (e) => {
        const $this = $(e.target);
        const $container = $this.closest('.design-package__package');
        const chargePerRoom = $this.is(':checked');
        $container.find('.select-field--rooms-number').prop('disabled', chargePerRoom);
        // Charging per room needs the client's room selection to price the package, so the
        // server forces rooms_enabled on. Lock the switch to match, disabling its hidden "0"
        // field together with the checkbox so the form does not submit "off" for it.
        if (chargePerRoom) {
          $container.find('.green-checkbox--rooms-enabled').prop('checked', true);
        }
        $container.find('input[name$="[rooms_enabled]"]').prop('disabled', chargePerRoom);
      });

      $(document).on('change', '.green-checkbox--free-consultation-enabled', (e) => {
        const $checkbox = $(e.target);
        // The input sits inside UI::Switch's own label now, so parent() is that label.
        const $package = $checkbox.closest('.design-package__package');
        if ($checkbox.is(':checked')) {
          $package.removeClass('design-package__package--free-consultation-hidden');
        } else {
          $package.addClass('design-package__package--free-consultation-hidden');
        }
      });

      // room selector
      const updateRoomSelectorLabel = ($container) => {
        const checkedOptions = $container.find('.checkbox--covered-room:checked');
        const options = $container.find('.checkbox--covered-room');

        let label;
        if (options.length === checkedOptions.length) {
          label = 'All Room Types';
        } else {
          label = checkedOptions
            .map((i, el) => el.value)
            .get()
            .join(', ');
        }

        $container.find('.room-selector__label').text(label);
      };
      $('.room-selector').each((_, e) => {
        updateRoomSelectorLabel($(e));
      });

      $(document).on('click', '.room-selector', (e) => {
        const $this = $(e.target);
        let $container;

        if ($this.is('.room-selector__label')) {
          $container = $this.closest('.room-selector');
        } else if ($this.is('.room-selector')) {
          $container = $this;
        }
        if ($container) {
          $container.toggleClass('room-selector--active');
        }
      });
      $(document).on('change', '.room-selector__options input[type=checkbox]', (e) => {
        const $this = $(e.target);
        const $container = $this.closest('.room-selector');
        const checkedOptions = $container.find('input[type=checkbox]:checked');

        // at least one options has to be checked
        if (!checkedOptions.length) {
          $this.prop('checked', true);
          return false;
        }

        updateRoomSelectorLabel($container);
      });

      $('.update-design-packages-background-button__input').fileupload({
        url: '/user_files',
        add(e, data) {
          const file = data.files[0];

          if (!isValidImage(file)) {
            return false;
          }

          file.uploadName = stripFileName(file.name);
          const reader = new FileReader();
          reader.onload = function (event) {
            prepareImagePreview(event.target.result, file.name, 88).then((imgData) => {
              if (imgData) {
                data.submit();
              } else {
                alert(
                  'Invalid image. Please upload a valid JPEG, PNG, WEBP, AVIF, GIF, or HEIC file.'
                );
              }
            });
          };
          reader.readAsDataURL(file);
        },
        done: (_, data) => {
          const $result = $(data.result);
          $('.design-package__hero-background-image').css(
            'background-image',
            `url(${$result.data('background-image-url')})`
          );
          if (!$('.delete-design-packages-background-button').length) {
            $('main').append($result);
          }
        },
        fail: (_, data) => {
          alert(data.jqXHR.responseJSON.error);
        },
      });

      $(document).on('ajax:success', '.delete-design-packages-background-button', (e) => {
        $(e.target).remove();
        $('.design-package__hero-background-image').removeAttr('style');
      });

      $('html').click(function (e) {
        const $target = $(e.target);
        if (!$target.is('.room-selector, .room-selector *')) {
          $('.room-selector').removeClass('room-selector--active');
        }
      });

      $(document).on('change', '.green-checkbox--questionnaire-enabled', (e) => {
        const $el = $(e.target);
        const $package = $el.parents('.design-package__package');
        const $chargePerRoom = $package.find('.green-checkbox--charge-per-room');
        const $chargePerRoomLabel = $package.find('.green-checkbox-label--charge-per-room');

        if ($el.is(':checked')) {
          $chargePerRoom.prop('disabled', false);

          $chargePerRoomLabel.find('.df-tooltip__questionnaire-enabled-text').remove();
        } else {
          $chargePerRoom.prop('checked', false).change();
          $chargePerRoom.prop('disabled', true);

          $chargePerRoomLabel
            .find('.df-tooltip__text')
            .append(
              $(
                '<div class="df-tooltip__questionnaire-enabled-text"><strong>Enable Questionnaire to use this feature</strong></div>'
              )
            );
        }

        $package.find('.room-selector').toggleClass('room-selector--disabled');

        $package.find('.select-field--rooms-number').prop('disabled', $el.is(':not(:checked)'));

        $package.find('.select-field--design-package-questionnaire').toggle();
        return false;
      });

      $(document).on('change', '.green-checkbox--package-discount-enabled', (e) => {
        const $el = $(e.target);
        const $configLink = $el.parent().find('.design-package__discount-configure-link');
        $configLink.toggleClass('hide', $el.is(':not(:checked)'));
      });

      $(document).on('change', '.select-field--design-package-sales-tax', (e) => {
        if ($(e.target).val() === 'add_sales_tax') {
          e.target.dispatchEvent(new CustomEvent('sales-tax:add', { bubbles: true }));
        }

        return false;
      });

      $(document).on('change', '.select-field--design-package-questionnaire', (e) => {
        let questionnaireId = $(e.target).val();
        if (!questionnaireId) {
          questionnaireId = 0;
        }
        const $roomOptions = $(e.target).siblings('.room-selector').find('.room-selector__options');
        const packageIndex = $roomOptions.data('index');
        const teamSlug = $('meta[name="team-slug"]').attr('content');

        $.get(
          `/design-packages/${teamSlug}/xhr_choose_questionnaire/${questionnaireId}/${packageIndex}`,
          (data) => {
            $roomOptions.html(data);
            updateRoomSelectorLabel($roomOptions.closest('.room-selector'));

            if ($(e.target).siblings('.design-package__legacy-rooms-message')) {
              $(e.target).siblings('.design-package__legacy-rooms-message').remove();
            }
          }
        );
      });
    }

    $(document).on('click', '.design-package__label', (e) => {
      const $panel = $(e.target).closest('.design-package__panel ');
      $panel.find('.design-package__content').slideToggle();
      $panel.toggleClass('design-package__panel--expanded');
    });
  });
});
